import { FC } from 'react';
import { useCalculateProfileData } from '../hooks';
import { UserMetadataQueryContext } from './UserMetadataQueryContext';

export const UserMetadataQueryContextProvider: FC<React.PropsWithChildren<unknown>> = ({
  children,
}) => {
  const data = useCalculateProfileData();

  return (
    <UserMetadataQueryContext.Provider value={data}>{children}</UserMetadataQueryContext.Provider>
  );
};
